const autoNgTemplateLoaderTemplate1 = require('./viewLoading.html');

angular.module('portainer.kubernetes').component('kubernetesViewLoading', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    viewReady: '<',
  },
});
